import { ThemeUICSSObject } from '@apia/theme';
import { files } from './global/files';
import menu from './global/menu';
import print from './global/print';
import calendar from './stylesObjects/calendar';
import transitions from './global/transitions';

const stylesObject: () => ThemeUICSSObject = () => ({
  // Root styles
  color: 'palette.text.primary',
  fontFamily: 'body',
  fontWeight: 'body',
  fontSize: '100%',
  height: '100%',
  ...calendar(),
  ...files,
  ...menu,
  ...print,
  ...transitions,

  'input[type="radio"], input[type="checkbox"]': {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    position: 'relative  !important' as any,
    float: 'right',
  },
  'td, th, svg, ul, div.overlay, .switchBox, td button:not(.with-radio), td input, td select, .spacer, .mainContent, nav[id="TopBar"],.noScrollbar, .tabs__item__close':
    {
      borderRadius: '0 !important',
    },
});
export default stylesObject;
